import { MainLayout } from '@/components/Layout/Public'
import { MainLayout as AdminMainLayout } from '@/components/Layout/Admin/MainLayout'
import { Loader } from '@/components/Loader'
import Login from '@/features/admin/auth/routes/Login'
import { Contact, PortfolioRoutes } from '@/features/public'
import { queryClient } from '@/lib/tanstack-query'
import { lazyImport } from '@/utils/lazyImport'
import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

const { Home } = lazyImport(() => import('@/features/public'), 'Home')
const { AboutUs } = lazyImport(() => import('@/features/public'), 'AboutUs')
const { PortfolioLayout } = lazyImport(
  () => import('@/features/public'),
  'PortfolioLayout'
)
const { Testimonials } = lazyImport(
  () => import('@/features/public'),
  'Testimonials'
)
const router = createBrowserRouter([
  {
    path: '',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'aboutus',
        element: <AboutUs />,
      },
      {
        path: 'testimonials',
        element: <Testimonials />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },

      {
        path: 'portfolio',
        element: <PortfolioLayout />,
        children: PortfolioRoutes,
      },
    ],
  },
  {
    path: '/auth',
    element: <AdminMainLayout />,
    children: [
      {
        path: 'category',
        element: <h1>Category</h1>,
      },
      {
        path: 'project',
        element: <h1>Project</h1>,
      },
      {
        path: 'Contact',
        element: <h1>Contact</h1>,
      },
      {
        path: 'company',
        element: <h1>Company</h1>,
      },
      {
        path: 'team',
        element: <h1>team</h1>,
      },
      {
        path: 'testimonial',
        element: <h1>testimonial</h1>,
      },
    ],
  },
  {
    path: 'login',
    element: <Login />,
  },

  {
    path: '/app',
    element: <h1>Authenticated</h1>,
  },
])

export const AppRouter = () => {
  return (
    <>
      <Loader />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </>
  )
}
